import React, { useEffect, useState } from "react";
import { Breadcrumb, Row, Col, Card } from "antd";
import { Table } from "ant-table-extensions";
import http from "../../helpers/http";
import config from "../../config/config";

// Read-only report: lifetime public-profile view counts per business.
// total_views  = every recorded hit (repeat visits included)
// unique_views = distinct anonymous visitors
// Counts only anonymous public visitors (owners / logged-in users excluded at
// the source), and accrue from the day tracking was deployed onward.
function ProfileViews() {
  const [loading, setLoading] = useState(false);
  const [datas, setDatas] = useState([]);

  const moduleNamePural = "Profile Views";
  const base_url = config.api_url + "admin/business-profile-views";

  const fetchDatas = async () => {
    setLoading(true);
    const data = await http.get(base_url);
    if (data) {
      setDatas(data.data);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchDatas();
  }, []);

  const columns = [
    {
      title: "Business",
      dataIndex: "business_name",
      key: "business_name",
      sorter: (a, b) =>
        (a.business_name || "").localeCompare(b.business_name || ""),
      render: (text, record) => (
        <a
          href={record.profile_url}
          target="_blank"
          rel="noopener noreferrer"
        >
          {record.business_name || record.username}
        </a>
      ),
    },
    {
      title: "Total Views",
      dataIndex: "total_views",
      key: "total_views",
      defaultSortOrder: "descend",
      sorter: (a, b) => a.total_views - b.total_views,
    },
    {
      title: "Unique Viewers",
      dataIndex: "unique_views",
      key: "unique_views",
      sorter: (a, b) => a.unique_views - b.unique_views,
    },
  ];

  return (
    <div>
      <Breadcrumb style={{ margin: "16px 0" }}>
        <Breadcrumb.Item>Dashboard</Breadcrumb.Item>
        <Breadcrumb.Item>{moduleNamePural}</Breadcrumb.Item>
      </Breadcrumb>

      <Row>
        <Col span={24}>
          <div className="site-card-border-less-wrapper">
            <Card title={moduleNamePural} variant="borderless">
              <Table
                rowKey={(record) => record._id}
                columns={columns}
                dataSource={datas}
                loading={loading}
                searchable
              />
            </Card>
          </div>
        </Col>
      </Row>
    </div>
  );
}

export default ProfileViews;
